"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableStartDatesQuery = exports.generateCapacityQuery = exports.generateVariablesFromAvailableStartDates = void 0;
const generateArguments = (variables) => {
    let args = "";
    for (const key of Object.keys(variables)) {
        args += `$${key}: String!, `;
    }
    return args.substr(0, args.length - 2);
};
const generateQueryBody = (variables) => {
    let query = ``;
    Object.keys(variables).forEach((key, index) => {
        query += `
        premium${index}: capacityForecast(subscriptionModel: "premium", date: $${key}) {
        ...CapacityForecast
        }
        original${index}: capacityForecast(subscriptionModel: "original", date: $${key}) {
        ...CapacityForecast
        }
        plus${index}: capacityForecast(subscriptionModel: "plus", date: $${key}) {
        ...CapacityForecast
        }
        vip${index}: capacityForecast(subscriptionModel: "vip", date: $${key}) {
        ...CapacityForecast
        }
        pro${index}: capacityForecast(subscriptionModel: "pro", date: $${key}) {
        ...CapacityForecast
        }
    `;
    });
    return query;
};
const generateVariablesFromAvailableStartDates = (availableDates) => {
    const variables = {};
    if (!availableDates || availableDates.length === 0)
        return variables;
    availableDates.forEach((date, index) => {
        variables[`date${index}`] = date.iso8601.split("T")[0];
    });
    return variables;
};
exports.generateVariablesFromAvailableStartDates = generateVariablesFromAvailableStartDates;
const capacityForecastFragment = `
     fragment CapacityForecast on capacityForecastRecord {
        max
        reserved
        taken
      }
`;
const generateCapacityQuery = (variables) => {
    return `
        ${capacityForecastFragment}
        
        query getCapacity(${generateArguments(variables)}) {
            coach {
                ${generateQueryBody(variables)}
            }
        }    
    `;
};
exports.generateCapacityQuery = generateCapacityQuery;
const getAvailableStartDatesQuery = `
        query availableStartDates {
            availableStartDates {
            iso8601
         }
        }
      `;
exports.getAvailableStartDatesQuery = getAvailableStartDatesQuery;
//# sourceMappingURL=getCapacityQuery.js.map